import { cn } from 'noddi-ui-common';
import * as React from 'react';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex flex-col gap-6 rounded-xl border border-border bg-card p-6 text-card-foreground shadow-sm',
      className
    )}
    {...props}
  />
));
Card.displayName = 'Card';

const CardHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('flex justify-between gap-4', className)} {...props} />
);
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-lg font-semibold leading-none', className)} {...props} />
  )
);
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
  )
);
CardDescription.displayName = 'CardDescription';

export type NoddiCardProps = {
  className?: string;
  children?: React.ReactNode;
  headerNode?: React.ReactNode;
} & ({ title: string; description?: string } | { title?: never; description?: never });

export function NoddiCard({ title, description, children, headerNode, className }: NoddiCardProps) {
  const hasHeader = !!(title || headerNode);
  return (
    <Card className={className}>
      {hasHeader && (
        <CardHeader>
          <div className='flex flex-col gap-1.5'>
            {title && <CardTitle>{title}</CardTitle>}
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {headerNode}
        </CardHeader>
      )}
      {children}
    </Card>
  );
}
